(() => {
  const form = document.querySelector('[data-gm-guide-customer-form]');
  if (!form) return;

  const status = form.querySelector('[role="status"]');
  const success = form.querySelector('[data-gm-guide-success]');
  const storageKey = `gm-guide-subscription:${form.id}`;
  // Storage is optional: Shopify's server-rendered success/download also works without it.
  try {
    const result = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
    if (success && result?.accepted && Date.now() - result.at < 15 * 60 * 1000) {
      success.textContent = 'Check your email for the guide.';
    }
    sessionStorage.removeItem(storageKey);
  } catch (_) { /* Restricted storage must never interrupt the native form. */ }

  let pending = false;
  let submitToShopify = false;
  let submittedEmail;
  form.addEventListener('submit', async (event) => {
    // The second submit goes through normal browser/Shopify submit handlers.
    const emailField = form.elements.namedItem('contact[email]');
    if (submitToShopify && emailField.value.trim() === submittedEmail) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending || !form.reportValidity()) return;
    pending = true;
    const submitter = event.submitter;
    const email = emailField.value.trim();
    submittedEmail = email;
    emailField.readOnly = true;
    form.setAttribute('aria-busy', 'true');
    status.textContent = 'Sending your request…';
    let accepted = false;
    let timer;
    try {
      const controller = new AbortController();
      // Bound the entire enhancement, even if a browser extension stalls fetch.
      const deadline = new Promise((resolve) => {
        timer = setTimeout(() => { resolve(false); controller.abort(); }, 4000);
      });
      // Official Client Subscription schema, revision 2026-07-15:
      // https://developers.klaviyo.com/en/reference/create_client_subscription
      const request = fetch('https://a.klaviyo.com/client/subscriptions/?company_id=XfJDEQ', {
        method: 'POST',
        headers: {
          accept: 'application/vnd.api+json',
          'content-type': 'application/vnd.api+json',
          revision: '2026-07-15'
        },
        credentials: 'omit',
        signal: controller.signal,
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Defragging Your Mind guide',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email,
                    subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                  }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: 'X3DWR4' } } }
          }
        })
      }).then((response) => response.status === 202, () => false);
      accepted = await Promise.race([request, deadline]);
    } catch (_) { /* Klaviyo is optional; Shopify still receives the request. */ }
    finally {
      clearTimeout(timer);
      try {
        sessionStorage.setItem(storageKey, JSON.stringify({ accepted, at: Date.now() }));
      } catch (_) { /* The server-rendered receipt remains available. */ }
      pending = false;
      submitToShopify = true;
      emailField.readOnly = false;
      form.removeAttribute('aria-busy');
      // Preserve the Liquid-generated action, hidden fields and Shopify spam protection.
      form.requestSubmit(submitter || undefined);
    }
  });
})();
